import { ChangeDetectorRef, Component, HostListener, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { CtrlBaseComponent } from '../ctrl-base.component';
import { FullscreenService } from '../../services';
import { PfComponents } from '../../enums/pfComponents';
import { Router } from '@angular/router';
import { breakpoints } from '../../environments/environment.breakpoints';

@Component({
  selector: 'ct-view',
  templateUrl: './ct-view.component.html',
  styleUrls: ['./ct-view.component.css']
})
export class CtViewComponent extends CtrlBaseComponent {

  @Input() child: string;
  @Input() value: string;
  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;
  @ViewChild('plusMessageContainer', { read: ViewContainerRef }) messageContainer: ViewContainerRef;
  @ViewChild('plusDialogContainer', { read: ViewContainerRef }) dialogContainer: ViewContainerRef;
  @ViewChild('viewButtonContainer', { read: ViewContainerRef }) buttonContainer: ViewContainerRef;
  private isFullScreen: boolean = false;
  private title : string;
  private description: string;
  private lastViewCode : string;
  public isSmallSize : boolean = false;
  public isExtraSmall : boolean = false;
  debug: boolean;
  saveState: boolean;
  public buttonContainerMetadata : any;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.manageWindowResizing(window.innerWidth);
  }

  constructor(private fullscreenService : FullscreenService,
    private router : Router,
    private cdr : ChangeDetectorRef) {
    super();
  }

  ngAfterViewInit() {
    this.manageWindowResizing(window.innerWidth);
    this.checkButtonContainerMetadata();
    this.paintChildren(this.getMetaData(), this.target);
    this.fullscreenService.toggleFullscreen(this.isFullScreen);
  }

  private manageWindowResizing(width: number) {
    this.isSmallSize = width < breakpoints.L && width >= breakpoints.M;
    this.isExtraSmall = width >= breakpoints.S && width < breakpoints.M;
  }

  public goBack(): void {
    const currentUrl : string = this.router.url;
    let currentUrlParts : string[] = currentUrl.split('/');
    currentUrlParts.pop();
    const newUrl : string = currentUrlParts.concat(`${this.getLastViewCode()}`).join('/');
    this.router.navigateByUrl(newUrl);
  }

  private checkButtonContainerMetadata(): void {
    let viewMetadata : any[] = [];
    let buttonMedata : any;
    this.getMetaData().models.forEach((componentMetadata : any) => {
      if(componentMetadata.ctType === PfComponents.CtButtonCompressedContainer) buttonMedata = componentMetadata;
      else viewMetadata.push(componentMetadata);
    });
    if(buttonMedata) {
      this.buttonContainerMetadata = buttonMedata;
      this.cdr.detectChanges();
      const temMetadata : any = JSON.parse(JSON.stringify(this.getMetaData()));
      temMetadata.models = [buttonMedata];
      this.setButtonContainerOnView(temMetadata);
    } 
    this.getMetaData().models = viewMetadata;
  }

  private setButtonContainerOnView(buttonMedata: any) {
    this.paintChildren(buttonMedata, this.buttonContainer);
  }

  getDebug(): boolean { return this.debug }
  getSaveState(): boolean { return this.saveState }
  getIsFullScreen(): boolean { return this.isFullScreen }
  getTitle(): string { return this.title }
  getDescription(): string { return this.description }
  getLastViewCode(): string { return this.lastViewCode }

  setDebug(debug: any): void { this.debug = debug }
  setSaveState(saveState: boolean): void { this.saveState = saveState }
  setIsFullScreen(fullScreen: boolean): void { this.isFullScreen = fullScreen }
  setTitle(title: string): void { this.title = title }
  setDescription(description: string): void { this.description = description }
  setLastViewCode(lastViewCode: string): void { this.lastViewCode = lastViewCode }
}